import { Controller } from 'stimulus'
import { loader } from '~/common/helpers/google_maps_loader'

export default class extends Controller {
  static values = {
    address: String,
    zoom: Number,
    mapId: String,
  }

  connect() {
    this.loadMap()
  }

  async loadMap() {
    const [{ Geocoder }, { Map }, { AdvancedMarkerElement }] =
      await Promise.all([
        loader.importLibrary('geocoding'),
        loader.importLibrary('maps'),
        loader.importLibrary('marker'),
      ])

    this.paintMap(Geocoder, Map, AdvancedMarkerElement)
  }

  paintMap(Geocoder, Map, AdvancedMarkerElement) {
    const geocoder = new Geocoder()
    geocoder.geocode({ address: this.addressValue }, (results, status) => {
      if (status === 'OK') {
        const location = results[0].geometry.location
        this.map = new Map(this.element, {
          center: location,
          zoom: this.zoomValue,
          mapTypeControl: false,
          fullscreenControl: false,
          streetViewControl: false,
          rotateControl: false,
          mapId: this.mapIdValue,
        })

        new AdvancedMarkerElement({
          position: location,
          map: this.map,
        })
      } else {
        console.error('Could not Geocode your address:', status)
      }
    })
  }
}
